export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full max-w-[400px]">
            <div className="relative w-full aspect-square rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20digital%20reading%20scene%20with%20a%20tablet%20and%20smartphone%20displaying%20colorful%20manga%20pages%20on%20a%20wooden%20desk%2C%20soft%20natural%20light%20from%20window%2C%20surrounded%20by%20cozy%20elements%20like%20a%20warm%20drink%20and%20small%20plant%2C%20modern%20minimalist%20style%2C%20warm%20cream%20and%20wood%20tones%2C%20clean%20composition%2C%20relaxing%20atmosphere&width=800&height=800&seq=about-manga-platform&orientation=squarish"
                alt="尾巴漫画阅读平台"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
              关于尾巴
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              尾巴漫画创立于2020年，是专注于中文读者的免费漫画在线阅读平台。
              我们致力于打造国内最优质的漫画阅读体验，目前已收录超过5万部海内外精品漫画资源，
              涵盖韩漫、日漫、国漫三大品类，覆盖热血、恋爱、悬疑、奇幻、搞笑等全题材类型。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台独创下拉式竖屏阅读模式，无需翻页即可流畅浏览每一话内容，同时搭载高清画质引擎，
              确保每一格漫画都清晰锐利。我们与国内外多家漫画版权方及原创作者深度合作，
              所有内容均为正版授权，为读者提供安全、可靠、高品质的阅读环境。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              尾巴漫画始终相信：好的漫画，应该让每一个人都能轻松看到。
              8000万用户的信任，是我们不断前行的最大动力。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}